<template>
  <div id="app">
    <router-view />
    <van-tabbar v-model="active" v-if="$route.meta.isTabbar">
      <van-tabbar-item name="home" icon="home-o" to="/home"> 购票 </van-tabbar-item>
      <van-tabbar-item name="orderlist" icon="search" to="/orderList"> 验票 </van-tabbar-item>
      <van-tabbar-item name="blance" icon="gold-coin-o" to="/balance"> 钱包 </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import * as dd from 'dingtalk-jsapi';
import { Toast } from 'vant';
import Auth from '@/apis/Auth';
import Order from '@/apis/Order';

export default {
  data() {
    return {
      active: 0,
      detailInfo: {},
    };
  },
  beforeCreate() {
    const that = this;
    if (dd.env.platform != 'notInDingTalk') {
    dd.ready(() => {

      dd.runtime.permission.requestAuthCode({
        corpId: 'ding5afe027889e9ac43acaaa37764f94726',
        onSuccess(result) {
          console.log('钉钉数据获取成功 => ', result);
          const { code } = result;
          Auth.login(code).then((res) => {

            if (res.code === '1') {
             localStorage.setItem('setUserid',res?.data.userid || '');
              that.$store.commit('auth/setUserInfo', res?.data);
            }
          }).catch((err) => {
            toast.clear();
            console.error(err);
          });
        },
        onFail(err) {
          console.error('钉钉数据获取失败 ，', err);
        },
      });
    });
    }else{
      //console.log('请求钉钉了===');
      //that.$store.commit('auth/setUserInfo', {userid: '1315206829614120962'});
    };
  },
  beforeUpdate() {
   // this.queryData();

    if (this.$route.name === 'Home') {
      this.active = 'home';
    } else if (this.$route.name === 'OrderList') {
      this.active = 'orderlist';
    } else if (this.$route.name === 'Balance') {
      this.active = 'blance';
    }
  },
  computed: {
    statusName() {
      let res = '';
      switch (this.detailInfo?.order_status) {
        case 'created':
          res = '待支付';
          break;
        case 'cancel':
          res = '已取消';
          break;
        case 'expired':
          res = '已失效';
          break;
        case 'evaluation':
          res = '已评价';
          break;
        default:
          res = '已支付';
          break;
      }
      return res;
    },
  },
  methods: {

    async queryData() {
      const res = await Order.getDetail();
      const {
        code,
        data,
      } = res;
      if (Number(code) === 1) {
        this.detailInfo = data;
      }
      return res;
    },
    handleTicket() {
      console.log(this.statusName);
      if (this.statusName === '待支付') {
        this.$router.push('/order');
      } else {
        this.$router.push('/orderDetail');
      }
    },
  },
};
</script>

<style lang="scss">
@import "~@/assets/styles/variable.scss";

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.van-tabbar-item--active {
  color: $brand-color!important;
}
</style>
